import React from 'react';
import { IPagination } from '../../domain/interfaces/Dashboard';

type PaginationProps = {
    pagination: IPagination;
    onPageChange: (page: number) => void;
};

const range = (start: number, end: number) => {
    const list: number[] = [];
    for (let i = start; i <= end; i++) list.push(i);
    return list;
}

const Pagination: React.FC<PaginationProps> = ({ pagination, onPageChange }) => {
    //if (totalPages <= 1) return null;

    const canPrev = pagination.currentPage > 1;
    const canNext = pagination.currentPage < pagination.totalPages;

    // Construir una ventana de páginas: actual ±2, con límites [1, totalPages]
    const start = Math.max(1, pagination.currentPage - 2);
    const end = Math.min(pagination.totalPages, pagination.currentPage + 2);
    const pages = range(start, end);

    return (
        <div className="flex items-center justify-center gap-2 p-4">
            <button
                className={`px-3 py-1 rounded border dark:text-white text-xervix-text-primary text-sm ${canPrev ? 'bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700' : 'bg-gray-100 dark:bg-gray-700 opacity-60 cursor-not-allowed'}`}
                onClick={() => canPrev && onPageChange(pagination.currentPage - 1)}
                disabled={!canPrev}
            >
                Anterior
            </button>

            {start > 1 && (
                <>
                    <button
                        className="px-3 py-1 rounded border text-sm bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700"
                        onClick={() => onPageChange(1)}
                    >
                        1
                    </button>
                    {start > 2 && <span className="px-1 text-sm text-gray-500">...</span>}
                </>
            )}

            {pages.map(page => (
                <button
                    key={page}
                    className={`px-3 py-1 rounded border text-sm ${page === pagination.currentPage ? 'bg-xervix-primary text-white border-xervix-primary' : 'bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700'}`}
                    onClick={() => onPageChange(page)}
                >
                    {page}
                </button>
            ))}

            {end < pagination.totalPages && (
                <>
                    {end < pagination.totalPages - 1 && <span className="px-1 text-sm text-gray-500">...</span>}
                    <button
                        className="px-3 py-1 rounded border text-sm bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700"
                        onClick={() => onPageChange(pagination.totalPages)}
                    >
                        {pagination.totalPages}
                    </button>
                </>
            )}

            <button
                className={`px-3 py-1 rounded border dark:text-white text-xervix-text-primary text-sm ${canNext ? 'bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700' : 'bg-gray-100 dark:bg-gray-700 opacity-60 cursor-not-allowed'}`}
                onClick={() => canNext && onPageChange(pagination.currentPage + 1)}
                disabled={!canNext}
            >
                Siguiente
            </button>
        </div>
    );
}

export default Pagination;


